import React from 'react';
import HeroLP from '../../components/placement_test/HeroLP';
import Steps from '../../components/placement_test/Steps';
import Starterpack from '../../components/placement_test/Starterpack';
import CardCTA from '../../components/placement_test/CardCTA';

const LandingPage = () => {
  const handleCTAClick = () => {
    document.getElementById('card-cta-section').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen">
      <HeroLP onCTAClick={handleCTAClick} />
      <Steps />
      <Starterpack />
      <div id="card-cta-section">
        <CardCTA />
      </div>
    </div>
  );
};

export default LandingPage;